// extracted by mini-css-extract-plugin
export default {"diagramDecription":"circle-diagram_diagramDecription__u1M1-","configCircle":"circle-diagram_configCircle__DnnHu","recharts-surface":"circle-diagram_recharts-surface__zHIYl"};